import { format } from 'date-fns'
import type { IVersionInfo } from 'utils/interfaces'

export const getFrontendVersion = (): IVersionInfo => ({
  version: process.env.REACT_APP_VERSION || null,
  branch: process.env.REACT_APP_GIT_BRANCH || null,
  commit: process.env.REACT_APP_GIT_COMMIT || null,
  buildTime: process.env.REACT_APP_BUILD_TIME || null,
  gitAhead: process.env.REACT_APP_GIT_AHEAD || null,
})
